import React, { useCallback, useEffect } from 'react';
import { useFormik } from 'formik';
import { toast } from "react-toastify";

import PassCode from './PassCode';

function PassCodeContainer({ onSubmit, loading }) {
	const { values, setFieldValue } = useFormik({
		initialValues: {
			otp0: '',
			otp1: '',
			otp2: '',
			otp3: '',
			otp4: ''
		}
	});

	const isNumber = useCallback(value => value.match(/^[0-9]$/), []);

	const setEspecificOtpValue = useCallback((value, position) => {
		if (position < 0 || position > 4) {
			return;
		}

		const name = `otp${position}`;

		setFieldValue(name, value);
	}, [setFieldValue]);

	const isFilled = useCallback(() => {
		return Object.values(values).every(value => value || value === 0);
	}, [values]);

	const handleBackspaceClick = useCallback(position => {
		const currentElementValue = values[`otp${position}`];

		currentElementValue ? setEspecificOtpValue('', position) : setEspecificOtpValue('', position - 1);

		const previousElement = document.getElementById(`otp${position - 1}`);

		if (previousElement && !currentElementValue) {
			previousElement.focus();
		}
	}, [setEspecificOtpValue, values]);

	const onKeyUpOtpInput = useCallback((event, position) => {
		if (event.key === 'Backspace') {
			handleBackspaceClick(position);
			return;
		}

		const value = event.key;

		if (!value || !isNumber(value)) {
			return;
		}

		setEspecificOtpValue(value, position);

		const nextElement = document.getElementById(`otp${position + 1}`);

		if (nextElement) {
			nextElement.focus();
		} else {
			event.target.blur();
		}
	}, [setEspecificOtpValue, handleBackspaceClick, isNumber]);

	const isValidCode = useCallback((str) => {
		return str.length === 5 && /^\d+$/.test(str);
	}, []);

	const handleSubmit = useCallback(() => {
		const code = Object.values(values).join('');

		if (!isValidCode(code)) {
			toast.error("Código inválido!");
			return;
		}

		onSubmit(code);
	}, [onSubmit, values, isValidCode]);

	useEffect(() => {
		if (isFilled()) {
			handleSubmit();
		}
	}, [values, isFilled, handleSubmit]);


	const onPaste = useCallback(event => {
		const clipboardData = (event.originalEvent || event).clipboardData || window.clipboardData;

		const fiveDigitsCpfArray = clipboardData.getData('text').split('');

		const hasInvalidPasteElements = fiveDigitsCpfArray.some(value => !isNumber(value));

		if (hasInvalidPasteElements) {
			return;
		}

		for (let position = 0; position < 5; position++) {
			setEspecificOtpValue(fiveDigitsCpfArray[position], position);
		}
	}, [isNumber, setEspecificOtpValue]);

	return (
		<PassCode
			values={values}
			loading={loading}
			onKeyUpOtpInput={onKeyUpOtpInput}
			onPaste={onPaste}
		/>
	);
}

export default PassCodeContainer;
